import { CdkScrollable } from '@angular/cdk/overlay';
import { Injectable, Optional } from '@angular/core';

import { EMPTY } from 'rxjs';

import { EmojiPickerService, EmojiSupportService } from '@recruitee/emoji';
import {
  BasicPlugin,
  BoldPlugin,
  ConfigPlugins,
  ContextMenuPlugin,
  EmojiEditorPlugin,
  ItalicPlugin,
  LinkEditPlugin,
  ListPlugin,
  MentionsPlugin,
  PluginsButtons,
  StrikethroughPlugin,
  UnderlinePlugin,
} from '@recruitee/prosemirror';

import { ContextToolbarService } from '../components/context-toolbar/context-toolbar.service';
import { LinkComponentService } from '../components/link-input/link-component.service';
import { MentionsListService } from '../components/mentions/mentions-list.service';
import { ToolbarService } from '../components/toolbar/toolbar.service';
import { ScrollStream$ } from '../consts';
import { ProsemirrorDefaultConfig } from './default-config';

@Injectable()
export class ProsemirrorViewboxConfig extends ProsemirrorDefaultConfig {
  constructor(
    emojiSupportService: EmojiSupportService,
    // This services are only used for editor mode
    @Optional() emojiPickerService?: EmojiPickerService,
    @Optional() toolbarService?: ToolbarService,
    @Optional() contextMenuService?: ContextToolbarService,
    @Optional() mentionsListService?: MentionsListService,
    @Optional() linkService?: LinkComponentService,
    @Optional() scrollStream$?: ScrollStream$,
  ) {
    super(
      emojiSupportService,
      EMPTY,
      emojiPickerService,
      toolbarService,
      contextMenuService,
      mentionsListService,
      linkService,
      scrollStream$,
    );
  }

  public getEditorPlugins() {
    return <
      (
        | BasicPlugin
        | ContextMenuPlugin
        | EmojiEditorPlugin
        | BoldPlugin
        | ItalicPlugin
        | StrikethroughPlugin
        | UnderlinePlugin
        | LinkEditPlugin
        | ListPlugin
      )[]
    >super.getEditorPlugins().filter(plugin => !(plugin instanceof MentionsPlugin));
  }

  public registerToolbarButtons(buttons: PluginsButtons<ConfigPlugins<ProsemirrorDefaultConfig>>) {
    super.registerToolbarButtons(buttons);
    this.toolbarService!.setRightButtons([buttons.toggleEmojiList]);
  }
}
